import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function BookList() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [books,   setBooks]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");

  const loadBooks = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/library/books/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setBooks(res.data.books || []);
    } catch (err) { console.error(err); alert("Failed to load books"); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadBooks(); }, []);

  const filtered = books.filter(b => {
    const q = search.toLowerCase();
    return b.title.toLowerCase().includes(q) ||
      (b.author && b.author.toLowerCase().includes(q)) ||
      (b.isbn && b.isbn.toLowerCase().includes(q));
  });

  const downloadExcel = async () => {
    try {
      const res = await API.get("/school-admin/library/books/export/", {
        headers: { "X-SCHOOL-ID": school.school.id },
        responseType: "blob",
      });
      const url  = URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "library_books.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) { console.error(err); alert("Download failed"); }
  };

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">📚</div>
          <div>
            <h2 className="lb-hero-title">Books</h2>
            <p className="lb-hero-sub">Library catalog — {books.length} books</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-excel" onClick={downloadExcel}>📥 Export Excel</button>
          <button className="lb-btn-add" onClick={() => navigate("/school-admin/library/books/add")}>
            + Add Book
          </button>
        </div>
      </div>

      {/* ══ FILTER ══ */}
      <div className="lb-filter">
        <span className="lb-filter-label">Search</span>
        <input
          className="lb-search"
          placeholder="🔍  Search by title, author, ISBN…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {/* ══ TABLE ══ */}
      <div className="lb-card">
        {loading ? (
          <div className="lb-empty">
            <div className="lb-empty-icon">⏳</div>
            <strong>Loading books…</strong>
          </div>
        ) : filtered.length === 0 ? (
          <div className="lb-empty">
            <div className="lb-empty-icon">📭</div>
            <strong>No books found</strong>
            <p>Try a different search or add your first book</p>
          </div>
        ) : (
          <table className="lb-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Author</th>
                <th>Category</th>
                <th>ISBN</th>
                <th>Copies</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(b => (
                <tr key={b.id}>
                  <td><span className="lb-book-title">{b.title}</span></td>
                  <td>{b.author || "—"}</td>
                  <td>
                    {b.category_name
                      ? <span style={{ background:"#dbeafe", color:"#1e40af", padding:"3px 10px", borderRadius:"20px", fontSize:"11px", fontWeight:700 }}>{b.category_name}</span>
                      : <span style={{ color:"#94a3b8" }}>—</span>
                    }
                  </td>
                  <td>{b.isbn || "—"}</td>
                  <td><span className="lb-pill available">{b.total_copies}</span></td>
                  <td>
                    <button
                      className="lb-btn-copies"
                      onClick={() => navigate(`/school-admin/library/books/${b.id}/copies`)}
                    >
                      📋 Copies & Issues
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}
